export const MinimumWagesSection = {
  countries: [
    {
      country: "India",
      section: "Minimum Wage",
      details: {
        category: "General",
        description: "The national minimum wage in India is fixed by the respective state governments. It uses a complex method of setting minimum wages that defines thousands of different jobs for unskilled workers and over 400 categories of employment, with a minimum daily wage for each type of job.",
        update: {
          new_law: "The new Labour Code has introduced an increase of 14.5 times on the existing minimum wage.",
          new_wage: "Rs 15,000 per month",
        },
      },
    },
    {
      country: "United Kingdom",
      section: "Minimum Wage",
      details: {
        category: "General",
        description: "The national minimum wage in the United Kingdom is set by the government, and it varies by age and whether the worker is an apprentice. The minimum wage is reviewed annually.",
        update: {
          new_law: "Annual increase in national minimum wage rates.",
          new_wage: "£8.91 per hour (for workers aged 23 and over)",
        },
      },
    },
    {
      country: "Germany",
      section: "Minimum Wage",
      details: {
        category: "General",
        description: "Germany has a statutory minimum wage law that applies to all workers above 18 years of age. The rate is adjusted every two years based on recommendations from a commission.",
        update: {
          new_law: "New adjustments to the minimum wage have been made every two years.",
          new_wage: "€9.60 per hour",
        },
      },
    },
    {
      country: "United States",
      section: "Minimum Wage",
      details: {
        category: "General",
        description: "In the United States, the federal minimum wage is set by the government, but many states and localities have their own minimum wage laws that are higher than the federal rate.",
        update: {
          new_law: "The federal minimum wage rate remains at $7.25 per hour, but many states have higher rates.",
          new_wage: "$7.25 per hour (federal minimum)",
        },
      },
    },
    {
      country: "Australia",
      section: "Minimum Wage",
      details: {
        category: "General",
        description: "Australia's national minimum wage is set by the Fair Work Commission, and it applies to all full-time and part-time workers unless covered by a modern award or enterprise agreement.",
        update: {
          new_law: "The minimum wage is updated annually by the Fair Work Commission.",
          new_wage: "AU$20.33 per hour",
        },
      },
    },
  ],
};
